import { Box, Button, Flex, HStack, Text, Textarea, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

export default function XmlSetting() {
   const [xmlOutput, setXmlOutput] = useState('');

   // Your JSON data stored in a variable
   const jsonData = {
      envelope: {
         body: {
            importData: {
               requestData: {
                  tallyMessages: [
                     {
                        ledger: {
                           name: 'Profit & Loss A/c',
                           reservedName: 'Profit & Loss A/c',
                           startingFrom: '20240401',
                           guid: '60e0a07b-0332-4276-9b76-c04d6899f8d9-0000001e',
                           parent: '',
                           taxClassificationName: 'Not Applicable',
                           taxType: 'Others',
                           gstType: 'Not Applicable',
                           appropriateFor: 'Not Applicable',
                           gstTypeOfSupply: 'Services',
                           serviceCategory: 'Not Applicable',
                           exciseLedgerClassification: 'Not Applicable',
                           exciseDutyType: 'Not Applicable',
                           exciseNatureOfPurchase: 'Not Applicable',
                           ledgerFbtCategory: 'Not Applicable',
                           isBillWiseOn: 'No',
                           isCostCentresOn: 'No',
                           isInterestOn: 'No',
                           allowInMobile: 'No',
                           isCostTrackingOn: 'No',
                           isBeneficiaryCodeOn: 'No',
                           isExportOnVchCreate: 'No',
                           plasIncomeExpense: 'No',
                           isUpdatingTargetId: 'No',
                           isDeleted: 'No',
                           isSecurityOnWhenEntered: 'No',
                           asOriginal: 'Yes',
                           isCondensed: 'No',
                           affectsStock: 'No',
                           isRateInclusiveVat: 'No',
                           forPayroll: 'No',
                           isAbcEnabled: 'No',
                           isCreditDaysChkOn: 'No',
                           interestOnBillWise: 'No',
                           overrideInterest: 'No',
                           overrideAdvInterest: 'No',
                           useForVat: 'No',
                           ignoreTdsExempt: 'No',
                           isTcsApplicable: 'No',
                           isTdsApplicable: 'No',
                           isFbtApplicable: 'No',
                           isGstApplicable: 'No',
                           isExciseApplicable: 'No',
                           isTdsExpense: 'No',
                           isEdliApplicable: 'No',
                           isRelatedParty: 'No',
                           useForEsiEligibility: 'No',
                           isInterestInclLastDay: 'No',
                           appropriateTaxValue: 'No',
                           isBehaveAsDuty: 'No',
                           interestInclDayOfAddition: 'No',
                           interestInclDayOfDeduction: 'No',
                           isOthTerritoryAssessee: 'No',
                           ignoreMismatchWithWarning: 'No',
                           useAsNotionalBank: 'No',
                           behaveAsPaymentGateway: 'No',
                           overrideCreditLimit: 'No',
                           isAgainstFormC: 'No',
                           isChequePrintingEnabled: 'No',
                           isPayUpload: 'No',
                           isPayBatchOnlySal: 'No',
                           isBnfCodeSupported: 'No',
                           allowExportWithErrors: 'No',
                           considerPurchaseForExport: 'No',
                           isTransporter: 'No',
                           isEcashLedger: 'No',
                           useForNotionalItc: 'No',
                           isEcommOperator: 'No',
                           overrideBasedOnRealization: 'No',
                           isEcDiffInsDate: 'No',
                           showInPaySlip: 'No',
                           useForGratuity: 'No',
                           isTdsProjected: 'No',
                           isSalaryMulFile: 'No',
                           forServiceTax: 'No',
                           isInputCredit: 'No',
                           isExempted: 'No',
                           isAbatementApplicable: 'No',
                           isStxParty: 'No',
                           isStxNonRealizedType: 'No',
                           useForKkc: 'No',
                           useForSbc: 'No',
                           isUsedForCvd: 'No',
                           ledBelongsToNonTaxable: 'No',
                           isExciseMerchantExporter: 'No',
                           isPartyExempted: 'No',
                           isSezParty: 'No',
                           tdsDeducteeIsSpecialRate: 'No',
                           isEchequeSupported: 'No',
                           isEddSupported: 'No',
                        },
                     },
                  ],
               },
            },
         },
      },
   };

   // Function to convert JSON object to XML with uppercase tags
   const jsonToXml = (obj, rootName = null) => {
      let xml = '';

      if (rootName) {
         const upperRootName = rootName.toUpperCase();
         xml += `<${upperRootName}>`;
      }

      for (const key in obj) {
         if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const upperKey = key.toUpperCase();

            if (typeof value === 'object' && value !== null) {
               if (Array.isArray(value)) {
                  // Handle arrays
                  value.forEach((item) => {
                     xml += `<${upperKey}>`;
                     xml += jsonToXml(item);
                     xml += `</${upperKey}>`;
                  });
               } else {
                  // Handle objects
                  xml += `<${upperKey}>`;
                  xml += jsonToXml(value);
                  xml += `</${upperKey}>`;
               }
            } else {
               // Handle primitive values
               xml += `<${upperKey}>${value}</${upperKey}>`;
            }
         }
      }

      if (rootName) {
         const upperRootName = rootName.toUpperCase();
         xml += `</${upperRootName}>`;
      }

      return xml;
   };

   // Function to format XML with proper indentation
   const formatXml = (xml) => {
      let formatted = '';
      let indent = '';
      const tab = '  ';

      xml.split(/>\s*</).forEach((node) => {
         if (node.match(/^\/\w/)) {
            indent = indent.substring(tab.length);
         }
         formatted += indent + '<' + node + '>\n';
         if (node.match(/^<?\w[^>]*[^\/]$/)) {
            indent += tab;
         }
      });

      return formatted.substring(1, formatted.length - 2);
   };

   const convertToXml = () => {
      try {
         const xmlString = jsonToXml(jsonData);
         const formattedXml = formatXml(xmlString);
         setXmlOutput(formattedXml);
      } catch (error) {
         setXmlOutput('Error converting JSON to XML: ' + error.message);
      }
   };

   const copyToClipboard = () => {
      navigator.clipboard.writeText(xmlOutput);
   };

   const downloadXml = () => {
      const blob = new Blob([xmlOutput], { type: 'application/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'tally-import.xml';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
   };

   return (
      <>
         <Box mx="auto">
            <Flex mt="30px" justifyItems={'center'} gap={4}>
               <Link to="/admin/setting">
                  <Button mb="15px">
                     <IoMdArrowRoundBack size={18} />
                  </Button>
               </Link>

               <HStack mb={6} justify="space-between">
                  <Text fontSize="2xl" fontWeight="bold">
                     XML Generate
                  </Text>
               </HStack>
            </Flex>

            <VStack spacing={6} align="stretch">
               <Box>
                  <Text fontSize="lg" fontWeight="semibold" mb={4}>
                     JSON Data Preview:
                  </Text>
                  <Box
                     bg="gray.50"
                     p={4}
                     borderRadius="md"
                     border="1px solid"
                     borderColor="gray.200"
                     maxH="200px"
                     overflowY="auto">
                     <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>{JSON.stringify(jsonData, null, 2)}</pre>
                  </Box>
               </Box>

               <HStack spacing={4}>
                  <Button colorScheme="blue" onClick={convertToXml}>
                     Convert to XML
                  </Button>
                  {xmlOutput && (
                     <>
                        <Button variant="outline" onClick={copyToClipboard}>
                           Copy XML
                        </Button>
                        <Button variant="outline" onClick={downloadXml}>
                           Download XML
                        </Button>
                     </>
                  )}
               </HStack>

               {xmlOutput && (
                  <Box>
                     <Text fontSize="lg" fontWeight="semibold" mb={4}>
                        Generated Tally XML:
                     </Text>
                     <Textarea
                        value={xmlOutput}
                        readOnly
                        minH="400px"
                        bg="gray.50"
                        fontFamily="monospace"
                        fontSize="sm"
                        border="1px solid"
                        borderColor="gray.200"
                     />
                  </Box>
               )}
            </VStack>
         </Box>
      </>
   );
}
